import React, { useState } from 'react';
import {
	Row, Col, Input, Modal, Form, notification, Divider
} from 'antd';
// import moment from 'moment';
// import _ from 'lodash';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

const Index = ({
    userData,
	visible,
	onCancel
}) => {

	const [isSaving, setSaving] = useState(false);

	const [form] = Form.useForm();
	const [ changeUserPassword ] = useMutation(CHANGE_PASSWORD);


	const onSubmit = (values) => {
        console.log('values', values);

        const postParams = Object.assign({}, values, {
            user_uid: userData.uid
        });

		console.log('postParams', postParams);
		setSaving(true);
        changeUserPassword({ 
            variables: { input: postParams },
            refetchQueries: ['systemUsers']
        }).then(resp => {
            setSaving(false);
			notification.open({ type: 'success', message: 'CHANGE PASSWORD', description: 'Password Successfully changed', placement: 'bottomRight' });
            onCancel();
        })
        .catch(err => {
			console.log('error', err);
            setSaving(false);
			notification.open({ type: 'error', message: 'CHANGE PASSWORD', description: err.message, placement: 'bottomRight' });
			onCancel();
        });
	};

	const onSubmitFailed = ({ errorFields }) => {
		form.scrollToField(errorFields[0].name);
	};

	return (
		<Modal
			// title={`Transaction ${transaction.uid} - (${transaction.customer_name})`}
			title='Change Password'
            okText='Confirm'
            width={(window.innerWidth < 600) ? '90%' : '30%'}
            onCancel={onCancel}
            onOk={() => form.submit()}
            visible={visible}
            confirmLoading={isSaving}
            maskClosable={false}
			// footer={null}
		>
			<Form
                form={form}
                onFinish={onSubmit} 
				onFinishFailed={onSubmitFailed}
            >
				<Row gutter={16} justify='center'>
					<Col md={22} sm={24}>
						<Form.Item 
							name='old_password'
							rules={[{ required: true }]}
						>
							<Input.Password placeholder='Enter current password' />
						</Form.Item>
                        <Divider type="horizontal" />
                        <Form.Item 
							name='confirm_password'
							rules={[{ required: true }]}
						>
							<Input.Password placeholder='Enter new password' />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

const CHANGE_PASSWORD = gql`
    mutation changeUserPassword($input: JSON) {
		changeUserPassword(input: $input)
    }
`;

export default Index;
